function addressLineValidator({ input, msgs }) {
  const rule = /^[a-zA-Z0-9\- '.#/]+$/;

  if (!rule.test(input)) {
    return msgs.msg || 'Invalid address line';
  }

  return null;
}

export default addressLineValidator;
